/**
 * Storage Keys Constants
 * 
 * Centralized localStorage key definitions to prevent typos
 * and ensure consistency across the application.
 * 
 * NOTE: Authentication is now handled by Firebase Auth.
 * The USER_REGISTERED, USER_EMAIL, and USER_FULLNAME keys are
 * kept for backward compatibility and UI state only.
 * Firebase automatically handles session persistence.
 */

export const STORAGE_KEYS = {
  // User authentication (legacy - now synced from Firebase User)
  // These are populated from Firebase User object for backward compatibility
  USER_REGISTERED: 'codee.user.registered',  // Synced from Firebase Auth state
  USER_EMAIL: 'codee.user.email',            // Synced from Firebase User.email
  USER_FULLNAME: 'codee.user.fullName',      // Synced from Firebase User.displayName
  
  // UI state
  SIDEBAR_COLLAPSED: 'codee.sidebar.collapsed',
  THEME: 'theme',
  
  // Dashboard
  DASHBOARD_PENDING_MESSAGE: 'codee.dashboard.pendingMessage',
};